import React from 'react';
import './radioField.scss';


interface Props {
    id: string;
    name: string;
    classname?: string;
    onblur?: (event: React.FocusEvent<HTMLInputElement>) => void | undefined;
    onchange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    text: string
    value?: string | number | readonly string[] | undefined;
    type?: string;
    checked?: boolean | undefined
}

const RadioField: React.FC<Props> = ({id, name, onchange, text, value, type = "radio", checked = undefined}) => {
    return (
        <label className={'radio-field'}>
            <input
                checked={checked}
                type={type}
                name={name}
                id={id}
                onChange={onchange}
                value={value}
                className={'radio-field__input'}
            />
            <div className="radio-field_custom"/>
            {text}
        </label>
    );
};

export default RadioField;
